export default __webpack_public_path__ + "static/media/CE.4c5be815.svg";